import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Avatar {
  id: number;
  skin: string | null;
  cheeks: boolean | null;
  hair_color: string | null;
  hair_front: string | null;
  hair_back: string | null;
  face: string | null;
  shirt_style: string | null;
  shirt_color: string | null;
  sleeve_length: string | null;
  pants_style: string | null;
  pants_color: string | null;
  glasses: string | null;
  beard: string | null;
  accessory: string | null;
}

@Injectable({ providedIn: 'root' })
export class AvatarService {
  private base = '/api/avatars';

  constructor(private http: HttpClient) {}

  /** Fetches the avatar attached to the authenticated user's profile. */
  getAvatar(avatarId: number): Observable<Avatar> {
    return this.http.get<Avatar>(`${this.base}/${avatarId}`);
  }

  /** Creates and attaches an avatar to the authenticated user's profile. */
  createAvatar(data: Partial<Avatar>): Observable<Avatar> {
    return this.http.post<Avatar>(this.base, data);
  }

  /** Updates the authenticated user's avatar. */
  updateAvatar(avatarId: number, data: Partial<Avatar>): Observable<Avatar> {
    return this.http.put<Avatar>(`${this.base}/${avatarId}`, data);
  }

  /** Deletes the authenticated user's avatar. */
  deleteAvatar(avatarId: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.base}/${avatarId}`);
  }

  /** Saves a profile-picture snapshot for the authenticated user. */
  saveSnapshot(snapshot: string): Observable<{ path: string }> {
    return this.http.post<{ path: string }>(`${this.base}/snapshot`, { snapshot });
  }
}
